import { render, staticRenderFns } from "./ListBnRetrClientsVal.vue?vue&type=template&id=60e8a922&scoped=true&"
import script from "./ListBnRetrClientsVal.vue?vue&type=script&lang=js&"
export * from "./ListBnRetrClientsVal.vue?vue&type=script&lang=js&"
import style0 from "./ListBnRetrClientsVal.vue?vue&type=style&index=0&id=60e8a922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8a922",
  null
  
)

export default component.exports